import React from "react";
import { Link } from "react-router-dom";

const JurusanSection = () => {
	const data = [
		{
			id: "1",
			img: "/assets/images/courses/4by3/16.jpg",
			title: "Pelatihan dan Pengembangan Karyawan",
			link: "https://youtu.be/r6G-srO9AWo",
			status: "Gratis",
			totalKaryawan: "300",
		},
		{
			id: "2",
			img: "/assets/images/courses/4by3/14.jpg",
			title: "Memaksimalkan Efektivitas Karyawan: Kiat Meraih Sukses",
			link: "https://youtu.be/fU4o_BKaUZE",
			status: "Gratis",
			totalKaryawan: "200",
		},
		{
			id: "3",
			img: "/assets/images/courses/4by3/15.jpg",
			title: "Meningkatkan Output Perusahaan dengan Pelatihan Karyawan",
			link: "https://youtu.be/fU4o_BKaUZE",
			status: "Gratis",
			totalKaryawan: "100",
		},
	];

	return (
		<section className="py-5 mt-3">
			<div className="container">
				<div className="row mb-5">
					<div className="col-12">
						<h2 className="fs-1 fw-bold text-center">
							<span className="position-relative z-index-9">
								Konten Katalog
							</span>
						</h2>
						<p className="mb-0 text-center">
							"Dalam solusi kami, kami menyediakan konten interaktif yang mudah
							digunakan dan menyenangkan untuk digunakan yang akan membantu Anda
							dan tim Anda mencapai potensi maksimal dan terlibat sepenuhnya
							dalam proses pelatihan"
						</p>
					</div>
				</div>

				<div className="row g-4">
					{data.map((data, index) => (
						<div
							className="col-md-6 col-xl-4"
							key={index}
							data-aos="zoom-in-down"
						>
							<div className="card shadow overflow-hidden bg-transparent">
								<div className="position-relative">
									<img className="card-img-top" src={data.img} alt="Card" />
									<div className="bg-overlay bg-dark opacity-4" />
									<div className="card-img-overlay">
										<div className="position-absolute top-50 start-50 translate-middle">
											{/* Video link */}
											<a
												href={data.link}
												className="btn btn-lg text-danger btn-round btn-white-shadow mb-0"
												data-glightbox
												data-gallery="video-tour"
											>
												<i className="fas fa-play" />
											</a>
										</div>
									</div>
								</div>
								<div className="card-body">
									<h5>
										<a href={data.link}>{data.title}</a>
									</h5>
									<div className="d-flex justify-content-between align-items-center mt-3">
										{/* Avatar Group */}
										<div>
											<h6 className="mb-1 fw-normal">
												<i className="fas fa-circle fw-bold knows-green1 small me-2" />
												{data.totalKaryawan} Karyawan
											</h6>
										</div>
										<Link to="/silabus" className="btn btn-sm btn-primary mb-0">
											Join now
										</Link>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default JurusanSection;
